<template>
  <div class="main2-content">
    <div class="panel-content">
      <!-- 二级 -->
      <div v-for="(item,index) in btn" :key="'two'+index">
        <!-- 二级大标题-->
        <div class="model-title" :class="{ active: layoutShow(index) }" @click="handleIndex(index)">
          <div class="model-line">
            <div>{{ btn[index].title }}</div>
            <div style="margin-top: 2px;">{{ btn[index].titleEn }}</div>
          </div>
          <div class="model-icon-left">
            <i :class="iconShow(index)"></i>
          </div>
        </div>
        <div class="layout-flex" v-if="layoutShow(index)">
          <!--二级 图片 中英文-->
          <div class="layout-flex-2" v-if="btn[index].img">
            <img :src="btn[index].img" style="width: 100%" />
          </div>
          <div class="layout-flex-1" v-if="btn[index].dec">
            <div class="flex-head">
              <div class="dec" v-html="btn[index].dec"></div>
              <div class="decEn" v-html="btn[index].decEn"></div>
              <img class="bottomBg" src="../../assets/image/esg/bottom2.png" alt="">
            </div>
          </div>
          <!-- 3级-->
          <div class="layout-flex-1" v-for="(item, index) in btn[index].list" :key="'three'+index" :name="index">
            <div class="flex-head">
              <div class="title"><div >{{ item.title }} </div><div>{{ item.titleEn }}</div></div>
              <template v-if="item.dec">
                <div class="decEn" v-html="item.dec"></div>
              </template>
              <template v-if="item.decEn">
                <div class="decEn" v-html="item.decEn"></div>
              </template>
              <img class="bottomBg" src="../../assets/image/esg/bottom2.png" alt="">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import config from "./config3";
import mixinMobile from "./mixinMobile";
export default {
  mixins: [mixinMobile],
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
@import url("./commonMobile.less");
// 主题颜色
@colorValue: #12A79D;
// 描述字体颜色
@fontValue: #666666;
// 板块背景色
@activeValue: #eaf8f9;

.model-title.active {
  background: linear-gradient(to right,#44C7BE, #12A79D 100%);
}
/deep/ul li {
  position: relative;
  line-height: 1.6;
}

/deep/ul li::before {
  content: ""; /* 或使用 \2022 等 Unicode */
  width: 8px;height: 8px;
  background: @colorValue;border-radius: 100%;
  display: inline-block;
  margin-right: 6px;
}
</style>
